import styled from 'styled-components';
import * as grid from 'view/styles/grid';

export const FooterContainer = styled.div`
    margin-top: ${grid.multiple(4.25).px};
    text-align: center;
`;

export const Container = styled.div`
    text-align: left;
`;
